import { BuyerInvoicesResponse, NotificationResponse } from '@types'
import { Service } from '@tino-frontend/adapters'
import { invoiceToNotificationTransform } from 'services/transformers'

export class NotificationService {
  private path = '/companies'

  constructor(private readonly http: Service) {
    this.http = http
  }

  list(companyId: string): Promise<NotificationResponse> {
    return this.http
      .get<unknown, BuyerInvoicesResponse>(
        `${this.path}/buyer/${companyId}/invoices`,
        {
          params: {
            'filter.status': 'pending',
          },
        }
      )
      .then(invoiceToNotificationTransform)
  }
}
